import { render, staticRenderFns } from "./question-list.vue?vue&type=template&id=d19f733c&scoped=true"
import script from "./question-list.vue?vue&type=script&lang=js"
export * from "./question-list.vue?vue&type=script&lang=js"
import style0 from "./question-list.vue?vue&type=style&index=0&id=d19f733c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19f733c",
  null
  
)

export default component.exports